import { AccountTransactionsList } from '../AccountTransactionsList/AccountTransactionsList'
import { useAccountsTransactionsFilters } from './hooks/useAccountsTransactionsFilters'

export const AccountsTransactions = () => {
  const { areFiltersInDefaultState, filters } = useAccountsTransactionsFilters()

  return (
    <AccountTransactionsList
      areFiltersInDefaultState={areFiltersInDefaultState}
      filters={filters}
    />
  )
}
